import classNames from 'classnames'
import {t} from 'i18next'
import {Dropdown, DropdownChangeParams} from 'primereact/dropdown'
import React from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import {getRequiredFormMessage} from '../../../ErrorText'

interface CompanyRelationshipType {
	label: string
	value: number
}

/**
 * Do not change those values. they are 1:1 from the db table company_relationship_type
 * @type {({label: string, key: number} | {label: string, key: number} |
 * {label: string, key: number} | {label: string, key: number} | {label: string, key: number})[]}
 */
export const companyRelationshipList: CompanyRelationshipType[] = [
	{label: 'company.relationship_type.head_office', value: 1},
	{label: 'company.relationship_type.company_branch', value: 2},
	{label: 'company.relationship_type.holding_partner', value: 3},
	{label: 'company.relationship_type.lehrvertriebsverbund_partner', value: 4},
	{label: 'company.relationship_type.subsidiary_company', value: 5}
]

export const CompanyRelationshipDropdown = () => {

	const {control} = useFormContext()

	const translatedLable = (option: CompanyRelationshipType) => {
		return option?.label ? t<string>(option.label) : t<string>('core.select')
	}

	return (
		<Controller
			name="id_company_relationship_type"
			control={control}
			rules={{required: getRequiredFormMessage('company.id_company_relationship_type')}}
			render={({field, fieldState}) => (
				<Dropdown
					id={field.name}
					appendTo={document.body}
					value={field.value || ''}
					valueTemplate={translatedLable}
					itemTemplate={translatedLable}
					options={companyRelationshipList}
					placeholder={t<string>('core.select')}
					className={classNames({'p-invalid': fieldState.error}, ' w-full')}
					onChange={(changeParams: DropdownChangeParams) => {
						field.onChange(changeParams.value)
					}}
				/>
			)}/>
	)
}